/*
* @TagTable.vue
* @Description 实时报警组件
* @Author jsh
* @Date 2021/6/28
*/
<template>
    <div class="table-item-box padding-l-none" style="padding: 10px;">
        <section style="height: 100%;">
            <!-- 表格 -->
            <el-table :data="tableInfos"
                      ref="tableInfos"
                      stripe
                      style="width: 100%;margin-bottom: 10px;height: calc(100% - 90px);"
                      :class="{'table': true, 'no-pagination': false}"
            >
                <el-table-column type="selection" :selectable="checkSelectable"/>
                <el-table-column v-for="(item, index) in colData" :key="index" :label="item.title" v-if="item.isShow"
                                 :min-width="item.minWidth">
                    <template v-if="item.value=='pictureList'" v-slot="scope">
                        <span style="white-space: nowrap;" title="点击图片查看大图">
                        	<el-image v-for="(r, i) in scope.row[item.value]" :key="i" :src="r" :preview-src-list="scope.row[item.value]" style="cursor: pointer;height: 40px;vertical-align: middle;margin-right: 5px;"></el-image>
                        </span>
                    </template>
                    <template v-else v-slot="scope">
                        <span style="white-space: nowrap;" :title="scope.row[item.value]">{{scope.row[item.value]}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="150px" v-if="videoPlay">
                    <template v-slot="scope">
                        <el-button type="primary" icon="el-icon-download" size="mini" @click.native="downVideo(scope.row, scope.$index)" title="下载报警视频"  v-if="Object.keys(scope.row.videos).length > 0"></el-button>
                        <el-dropdown split-button type="danger" @click="playAll(scope.row, scope.$index)" trigger="click" size="mini" v-if="Object.keys(scope.row.videos).length > 0 && false">
                            <i class="el-icon-caret-right"></i>
                            <el-dropdown-menu slot="dropdown" trigger="click">
                                <div v-for="(item, index) in scope.row.videos">
                                    <el-dropdown-item @click.native="play(item.vId, item.url)">{{ item.vId }} <i class="el-icon-caret-right"></i></el-dropdown-item>
                                </div>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </template>
                </el-table-column>
            </el-table>

            <!--分页工具条-->
            <Pagination
                    :currentPage="pagination.currentPage"
                    :total="pagination.total"
                    :pageSize="pagination.limit"
                    @handleSizeChangeSub="handleSizeChangeSub"
                    @handleCurrentChangeSub="handleCurrentChangeSub"
            />

            <!--查询工具条-->
            <el-col style="text-align: left;">
                <el-form :inline="true" :model="filters" ref="filters">
                    <el-form-item>查询条件：</el-form-item>
                    <el-form-item prop="alarm">
                        <el-select v-model="filters.alarm" placeholder="请选择报警类型" clearable @change="research">
                            <el-option v-for="(item,index) in alarmStatus" :key="item.state" :label="item.name"
                                       :value="item.state"></el-option>
                        </el-select>
                        <el-form-item prop="alarm">
                            <el-select v-model="filters.dealState" placeholder="请选择报警状态" clearable @change="research">
                                <el-option v-for="(value,key) in dealState" :key="key" :label="value"
                                           :value="key"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-form-item>
                    <el-form-item prop="duration" class="item-cnt-lhfs-0">
                        <el-date-picker
                                :picker-options="filters.pickerOptions"
                                v-model="filters.duration"
                                type="datetimerange"
                                range-separator="—"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                start-placeholder="报警开始时间"
                                end-placeholder="结束时间"
                        >
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button icon="el-icon-search" trigger="click" @click="research"> 查询</el-button>
                    </el-form-item>
                    <el-form-item style="position: absolute;top: 9px;right: 10px;margin: 0px;z-index: 3;">
                        <el-button icon="el-icon-warning" type="danger" size="mini" trigger="click" @click="dealRows">一键处理</el-button>
                        <el-button type="primary" icon="el-icon-download" size="mini" @click="downVideoAll" trigger="click" v-if="videoPlay">下载当前页报警视频</el-button>
                        <el-button type="primary" icon="el-icon-download" size="mini" @click="downVideoPictureAll" trigger="click" v-if="picturePlay">下载当前页报警截图</el-button>
                    </el-form-item>
                </el-form>
            </el-col>


        </section>
    </div>

</template>

<script>
// 报警组件
import ApiOam from '@/request/api-oam'
import ApiType from '@/request/api-type'
import Pagination from '@/components/Pagination'
import GlobalFun from "../../global/global-function";

export default {
    name: "AlarmRealTable",
    /**
     * @Des 组件引用
     * @Auth jsh
     * @Date 09:41 2021/6/28
     */
    components: {
        Pagination
    },
    /**
     * @Des 数据定义
     * @Auth jsh
     * @Date 09:41 2021/6/28
     */
    data() {
        return {
            /**
             * @Des 查询条件属性
             * @Auth jsh
             * @Date 09:41 2021/6/28
             */
            filters: {
                alarm: '',
                dealState: '',
                // 开始时间 - 结束时间
                duration: '',
                // 隐藏的时间
                pickerOptions: {
                    disabledDate(v) {
                        return v.getTime() > new Date().getTime()
                    }
                },
            },
            colData: [
                {title: "报警设备", value: "tagId", isShow: true, minWidth: "160px"},
                {title: "设备序号", value: "sid", isShow: true, minWidth: "80px"},
                {title: "绑定名称", value: "bindingName", isShow: true, minWidth: "80px"},
                {title: "报警名称", value: "alarmName", isShow: true, minWidth: "100px"},
                {title: "报警次数", value: "count", isShow: true, minWidth: "100px"},
                {title: "预警时间", value: "warning_date", isShow: true, minWidth: "160px"},
                {title: "报警时间", value: "alarm_date", isShow: true, minWidth: "160px"},
                {title: "报警截图", value:"pictureList", isShow: true, minWidth: "120px"},
                {title: "处理状态", value: "dealStateName", isShow: true, minWidth: "80px"},
            ],
            colOptions: [], //默认全选
            colSelect: [],
            // 表格信息
            tableInfos: [],
            pagination: {
                total: 0,
                startNum: 0,
                limit: 50,
                currentPage: 1
            },
            projectInfos: {},
            alarmStatus: [],
            dealState: {
                0: '预警中',
                1: '报警中',
            },
            videoPlay: false,
            picturePlay: false
        }
    },
    computed: {},
    created() {
        // url参数
        this.initUrlParams();
        this.setDefaultTableTitle();
        this.searchAlarmStatus();
    },
    mounted() {
    },
    /**
     * @Des 方法定义
     * @Auth jsh
     * @Date 09:42 2021/6/28
     */
    methods: {
        /**
         * 设置默认选中的表头
         * */
        setDefaultTableTitle() {
            this.colOptions = [];
            this.colSelect = [];
            this.colData.forEach((row, index) => {
                this.colOptions.push(row.title);
                this.colSelect.push(row.title);
            })
        },

        /**
         * @Des url参数
         * @Auth
         * @Date
         */
        initUrlParams() {
            let query = Object.assign({}, this.$route.query);
            if (!this.$checkEmpty(query.alarm)) {
                // 报警类型
                this.filters.alarm = Number(query.alarm);
            }
        },
        /**
         * 查询报警状态
         * */
        searchAlarmStatus() {
            this.$request.postJsonRequest(ApiType.findTypeApi, {
                projectId: this.$store.state.currentProjectId,
                type: "alarmTypes"
            }).then(result => {
                this.alarmStatus = Object.assign([], []);
                if (result.code == 0 && result.data.alarmTypes) {
                    this.alarmStatus = result.data.alarmTypes;
                    this.searchAlarm();
                }
            }).catch(error => {
                console.error('查询报警状态异常', ApiType.findTypeApi, error);
            })
        },

        /**
         * 重新搜索
         * */
        research() {
            this.pagination.total = 0;
            this.pagination.startNum = 0;
            this.searchAlarm();
        },
        /**
         * @Des 查询基站
         * @Auth jsh
         * @Date 09:42 2021/6/28
         */
        searchAlarm() {
            let startTime = '';
            let endTime = '';
            if (this.filters.duration) {
                startTime = this.filters.duration[0];
                endTime = this.filters.duration[1];
            }
            let alarms = [];
            if (this.filters.alarm == '') {
                this.alarmStatus.forEach((row, index) => {
                    alarms.push(row.state);
                })
            } else {
                alarms.push(this.filters.alarm);
            }
            let dealState = [];
            if (this.filters.dealState == '') {
                dealState.push(0);
                dealState.push(1);
            } else {
                dealState.push(this.filters.dealState);
            }
            this.$request.postJsonRequest(ApiOam.Search_Alarm_Uri, {
                projectId: this.$store.state.currentProjectId,
                alarms: alarms,
                beginTime: startTime == '' ? 0 : new Date(startTime).getTime(),
                endTime: endTime == '' ? 0 : new Date(endTime).getTime(),
                dealState: dealState,
                orderBy: {
                    alarm_date: 'desc'
                },
                total: this.pagination.total,
                startNum: this.pagination.startNum,
                limit: this.pagination.limit
            }).then(result => {
                // console.log(result)
                this.videoPlay = false;
                this.tableInfos = Object.assign([], []);
                this.pagination.total = result.total;
                if (result.total > 0) {
                    result.rows.forEach((row, index) => {
                        if (row.count == null) {
                            row.count = 1;
                        }
                        if (row.warningDate != null) {
                            row.warning_date = this.$moment(row.warningDate).format('YYYY-MM-DD HH:mm:ss');
                        }
                        if (row.alarmDate != null) {
                            row.alarm_date = this.$moment(row.alarmDate).format('YYYY-MM-DD HH:mm:ss');
                        }
                        if (row.dealDate != null) {
                            row.deal_date = this.$moment(row.dealDate).format('YYYY-MM-DD HH:mm:ss');
                        }
                        row.dealStateName = this.dealState[row.dealState]
                        row.videos = [];
                        if (row.videoId) {
                            if (row.videoId.indexOf(",") == -1) {
                                this.$request.postJsonRequest(ApiOam.Find_Video_Uri, {
                                    fileName: row.videoName,
                                }).then(result => {
                                    if (result.code == 0) {
                                        row.videos.push({
                                            vId: row.videoId,
                                            url: result.data,
                                            name: row.bindingName,
                                            fName: result.data.substring(result.data.lastIndexOf("/") + 1)
                                        })
                                    }
                                }).catch(error => {
                                    console.error('查询报警视频异常', ApiOam.Search_Alarm_Uri, error);
                                })
                            } else {
                                let videoIds = row.videoId.split(",");
                                let videoNames = row.videoName.split(",");
                                for (let i = 0; i < videoIds.length; i++) {
                                    if (videoNames[i]) {
                                        this.$request.postJsonRequest(ApiOam.Find_Video_Uri, {
                                            fileName: videoNames[i],
                                        }).then(result => {
                                            if (result.code == 0) {
                                                row.videos.push({
                                                    vId: videoIds[i],
                                                    url: result.data,
                                                    name: row.bindingName,
                                                    fName: result.data.substring(result.data.lastIndexOf("/") + 1)
                                                })
                                            }
                                        }).catch(error => {
                                            console.error('查询报警视频异常', ApiOam.Search_Alarm_Uri, error);
                                        })
                                    }
                                }
                            }
                            if (!this.videoPlay) {
                                this.videoPlay = true;
                            }
                        }
                        
                        row.pictureMap = {};
                        row.pictureList = [];
                        if(row.pictures){
                            let pictures = JSON.parse(row.pictures);
                            for(let key in pictures){
                                row.pictureMap[key] = pictures[key];
                                row.pictureList.push(pictures[key]);
                                this.picturePlay = true;
                            }
                        }
                    })
                    this.tableInfos = result.rows;
                }
            }).catch(error => {
                console.error('查询报警异常', ApiOam.Search_Alarm_Uri, error);
            })
        },
        /**
         * 处理报警
         */
        dealRow(row, index) {
            this.$confirm(
                    '确认处理设备【' + row.sid + '】的【' + row.alarmName + '】报警吗？', '询问',
                    {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        closeOnClickModal: false,
                        type: 'warning'
                    }
            ).then(_ => {
                //console.log('confirm');
                let alarms = [];
                alarms.push({
                    alarm: row.alarm,
                    sid: row.sid
                })
                let param = {
                    alarms: alarms
                };
                // 删除账户 交互
                this.requestDelete(param);
            }).catch(_ => {
                //console.log('cancel')
            });
        },
        /**
         * 处理多行
         * @param row
         */
        dealRows() {
            let selection = this.$refs.tableInfos.selection;
            if (selection.length == 0) {
                this.$message({
                    message: '请选择要处理的数据',
                    type: 'info',
                    showClose: true,
                    dangerouslyUseHTMLString: true
                });
                return false;
            }
            this.$confirm(
                    '确认批量处理选中的信息吗？', '询问',
                    {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        closeOnClickModal: false,
                        type: 'warning'
                    }
            ).then(_ => {
                let alarms = [];
                selection.forEach((row, index) => {
                    alarms.push({
                        alarm: row.alarm,
                        sid: row.sid
                    })
                })
                let param = {
                    alarms: alarms
                };
                this.requestDelete(param);
            });
        },
        requestDelete(param) {
            if (this.locked) return;
            this.locked = true;
            this.$request.postJsonRequest(ApiOam.Deal_Alarm_Uri, param).then(result => {
                if (result.code == 0) {
                    this.$message({
                        message: '处理成功',
                        type: 'success',
                        showClose: true,
                        dangerouslyUseHTMLString: true
                    });
                } else {
                    this.$message({
                        message: result.msg,
                        type: 'error',
                        showClose: true,
                        dangerouslyUseHTMLString: true
                    });
                }
                this.locked = false;
                this.research();
            }).catch(error => {
                this.locked = false;
                console.error('处理报警异常', ApiOam.Deal_Alarm_Uri, error);
            })
        },
        /**
         * @Des 当前页数据改变
         * @Auth
         * @Date 2021/6/4
         */
        handleCurrentChangeSub(val) {
            this.pagination.currentPage = val;
            this.pagination.startNum = this.pagination.limit * (val - 1);
            this.research();
        },
        /**
         * @Des 页长度改变
         * @Auth
         * @Date 2021/6/4
         */
        handleSizeChangeSub(val) {
            this.pagination.limit = val;
            this.pagination.currentPage = 1;
            this.pagination.startNum = 0;
            this.research();
        },
        /**
         * 是否选择
         * */
        checkSelectable(row) {
            return true;
        },

        /**
         * @Author ZhangBin
         * @Description //TODO 视频播放
         * @Date 10:14 2022/9/27
         * @Param
         * @return
         **/
        play(id, name) {
            console.log(id, name)

        },

        /**
         * @Author ZhangBin
         * @Description //TODO 视频播放
         * @Date 10:25 2022/9/27
         * @Param
         * @return
         **/
        playAll(row, index) {
            let videos = row.videos;
            console.log(videos)
        },

        downVideo(row, index){
            // 下载视频
            if(row.videos.length > 0){
                if(row.videos.length == 1){
                    this.$request.downFile(row.videos[0].url, row.videos[0].name + '-' + row.videos[0].fName);
                }else{
                    this.$request.downloadAll(row.videos, row.videos[0].name + '-' + row.videos[0].fName.substring(0, row.videos[0].fName.indexOf("-")) + '.zip');
                }
            }
        },

        downVideoAll(){
            // 下载视频
            let videos = [];
            if(this.tableInfos.length > 0){
                this.tableInfos.forEach((row, index) => {
                    if(row.videos.length > 0){
                        videos = videos.concat(row.videos);
                    }
                })
            }
            if(videos.length > 0){
                this.$request.downloadAll(videos, this.pagination.currentPage + '页报警视频.zip');
            }
        },
        
        downVideoPictureAll(){
            // 下载截图
            let pictures = [];
            if(this.tableInfos.length > 0){
                this.tableInfos.forEach((row, index) => {
                    for(let key in row.pictureMap){
                        pictures.push({
                            url: row.pictureMap[key],
                            fName: key + row.pictureMap[key].substring(row.pictureMap[key].lastIndexOf("."))
                        });
                    }
                })
            }
            if(pictures.length > 0){
                this.$request.downloadAll(pictures, this.pagination.currentPage + '页报警视频截图.zip');
                this.$message({
                    message: '下载中，请耐心等待...',
                    type: 'success',
                    showClose: true,
                    dangerouslyUseHTMLString: true
                });
            }
        },
        
    },


}
</script>

/* CSS */
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components_pages/Alarm/AlarmRealTable.vue